export default __webpack_public_path__ + "static/media/Icon-open-graph.bd7e86e6.svg";